module.exports = __webpack_public_path__ + "img/aktiv palyazatok_gomb.54e8fc13.png";